var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBj = function SvgBj(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "bj_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "M67.6-154h666v666h-666z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bj_svg__a)",
    transform: "translate(-52 118.4)scale(.7688)"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    strokeWidth: "1pt"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#319400",
    d: "M0-154h333v666H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffd600",
    d: "M333-154h666v333H333z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de2110",
    d: "M333 179h666v333H333z"
  })))));
};
export default SvgBj;